import { t } from '@transifex/native';

import { show } from 'pkg/actions/flashes';
import type { DuplicatePayload } from 'pkg/actions/sessions/interface';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';

export type { DuplicatePayload } from 'pkg/actions/sessions/interface';

export const deleteSession = async (
	organizationId: number,
	sessionId: number
): Promise<void> => {
	await sdk.destroy(
		endpoints.TrainingSessions.Delete(organizationId, sessionId)
	);
};

export const duplicate = async (
	organizationId: number,
	sessionId: number,
	payload: DuplicatePayload = {}
): Promise<[boolean, models.session.Session]> => {
	const request = await sdk.post(
		endpoints.TrainingSessions.Duplicate(organizationId, sessionId),
		{},
		payload
	);

	if (!request.ok) {
		show({
			title: t('Something went wrong'),
			message: t(`There was an issue duplicating your session.`),
		});

		return [false, null];
	}

	const response = await request.json();

	show({
		title: t('Successfully duplicated your session'),
	});

	return [true, response];
};
